import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_BG_IMAGE_URL } from '../../../../../define/consts/assets';
import { propBool, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import SlideSearchTitleIcon from '../../../../Icon/Svg/SlideSearchTitleIcon';
import ProffitSearchLandingPageKeyVisualLeft from './ProffitSearchLandingPageKeyVisualLeft';
import ProffitSearchLandingPageKeyVisualRight from './ProffitSearchLandingPageKeyVisualRight';
const ProffitSearchLandingPageKeyVisual = (props) => {
    const { isEndTrial, plan, showFormModal } = props;
    const style = useMemo(() => ({
        backgroundImage: `url("${PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_BG_IMAGE_URL}")`,
    }), []);
    return (_jsxs("section", Object.assign({ className: 'proffit_search_landing_page_key_visual', style: style }, { children: [_jsx("div", Object.assign({ className: 'key_visual_header' }, { children: _jsx(SlideSearchTitleIcon, { className: 'white' }) })), _jsxs("div", Object.assign({ className: 'key_visual_body' }, { children: [_jsx(ProffitSearchLandingPageKeyVisualLeft, { isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal }), _jsx(ProffitSearchLandingPageKeyVisualRight, { isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal })] }))] })));
};
ProffitSearchLandingPageKeyVisual.propTypes = {
    isEndTrial: propBool().isRequired,
    plan: propStr(),
    showFormModal: propFunc().isRequired,
};
ProffitSearchLandingPageKeyVisual.defaultProps = {
    plan: undefined,
};
export default ProffitSearchLandingPageKeyVisual;
